import React, { useState, useEffect, useRef } from 'react';
import useApiRequest from './useApiRequest.jsx';
import { domain } from './Domain.jsx';
import { useLoadingContext } from './LoadingContext.jsx';

const ContactList = ({ contacts, onDelete }) => {
    return (
        <div>
            {contacts.length > 0 && contacts.map((contact, index) => (
                <div key={contact.id} className='item border-bottom pb-2'>
                    <p className='m-0 fw-bold text-muted'>Name: {contact.name}</p>
                    <p className='m-0 fw-bold text-muted'>Subject: {contact.subject}</p>
                    <p className='m-0 fs-6 text-muted fs-6'>Message {contact.id}:<br />{contact.message}</p>
                    <div className='d-flex gap-2'>
                        <small>{contact.created_at}</small>
                        <small>{contact.address}</small>
                    </div>
                    <div className='d-flex gap-2'>
                        <button onClick={() => onDelete(contact.id)} className='btn btn-sm mt-2 btn-outline-danger'>Delete</button>
                    </div>
                </div>
            ))}
        </div>
    );
};

const ContactComponent = () => {
    const { setLoading } = useLoadingContext()
    const [contacts, setContacts] = useState([]);
    const { getRequest, deleteRequest } = useApiRequest();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                await fetchContacts();
            } catch (error) {
                console.error('Error fetching contacts:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const fetchContacts = async () => {
        const response = await getRequest(`${domain}/contact`);
        setContacts(response.body);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this contact?")) {
            setLoading(true)
            const response = await deleteRequest(`${domain}/contact/${id}`);
            setContacts(contacts.filter((contact) => contact.id !== id));
            setLoading(false)
        }
    };

    return (
        <div className='w-100'>
            <ContactList
                contacts={contacts}
                onDelete={handleDelete}
            />
        </div>
    );
};

export default ContactComponent;